import {useQuery} from "@tanstack/react-query";
import {api} from "../../../services";
import {ReceiptQuota} from "../../../services/receipt/receiptModel";
import {ErrorResponse} from "../../../services/models/error-response";

export const RECEIPT_QUOTA_KEY = ['receipt-quota'];

/**
 * Loads the current daily scan quota. Kept fresh but not spammed - the backend
 * is the source of truth and also returns an updated quota with every scan.
 */
export function useReceiptQuota(enabled = true) {
  return useQuery<ReceiptQuota, ErrorResponse>(
    RECEIPT_QUOTA_KEY,
    () => api.receipt.getQuota(),
    {
      staleTime: 30_000,
      retry: false,
      enabled,
    }
  );
}
